import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ComprehensivePhysiotherapyServices from "./sections/ComprehensivePhysiotherapyServices";
import OurSpecialisedTreatments from "./sections/OurSpecialisedTreatments";
import Footer from "@/reusable_sections/Footer";
import NeckPainServiceBox from "./sections/NeckPainServiceBox";
export default function ServicesPage() {
  return <div>
      <Header />
      <ComprehensivePhysiotherapyServices />
      <OurSpecialisedTreatments />
      <NeckPainServiceBox />
      <Footer />
    </div>;
}